<div class="row w-100 d-flex p-0 align-items-center item-row dashboard placeholder-glow">
    <!-- Header - Bijgewerkt -->
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block ps-md-4 ps-lg-2 ps-xl-4 ps-xxl-4 activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Verzoek -->
    <div class="col-8 col-sm-8 col-md-4 col-lg-4 col-xl-3 col-xxl-2 ps-4 ps-sm-4 ps-md-2 ps-lg-2 ps-xl-2 ps-xxl-2 activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Type -->
    <div class="col-xl col-xxl d-none d-xl-block activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Uitgevoerd -->
    <div class="col-xl col-xxl d-none d-xxl-block activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Door -->
    <div class="col-xxl d-none d-xxl-block col activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Stage -->
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>

    <!-- Header - Deadline -->
    <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xl col-xxl activityItem">
        <span class="placeholder bg-secundary w-100"></span>
    </div>
</div>